import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import * as analytics from '../../services/analytics';
import get from 'lodash/get';
import merge from 'lodash/merge';
import { Formik } from 'formik';
import classnames from 'classnames';
import * as yup from 'yup';
import './BOAEnrollmentOwnershipView.css';

const propTypes = {
  onSubmit: PropTypes.func,
};

class BOAEnrollmentOwnershipView extends PureComponent {
  constructor(props) {
    super(props);
    this.formValidationSchema = yup.object().shape({
      ownersCount: yup
        .number('Please provide a number to continue')
        .min(0)
        .integer('Please provide a whole number to continue')
        .required(`Please provide a number to continue`),
    });
    this.state = {
      isInProgress: false,
      isValid: this.formValidationSchema.isValidSync(this.initialFormValues),
    };
  }

  componentDidMount() {
    analytics.page('BOA - Enrollment Business Ownership');
  }

  handleInitialValidation = ({ initialValues }) => {
    return this.formValidationSchema.isValidSync(initialValues);
  };

  handleSubmit = (values) => {
    const { updateQuote, onSubmit, onNotifyError, quote } = this.props;
    const { ownersCount } = values;
    this.setState({
      isInProgress: true,
    });

    const updatedQuote = merge({}, quote, {
      application: {
        answers: {
          owners_count: parseInt(ownersCount, 10),
        },
      },
    });
    updateQuote(updatedQuote)
      .then(onSubmit)
      .catch((error) => {
        this.setState({
          isInProgress: false,
        });
        onNotifyError(error);
      });
  };

  handleChange = (e) => {
    const { handleChange } = this.form;
    this.setState({
      isValid: this.formValidationSchema.isValidSync({
        ownersCount: e.target.value,
      }),
    });
    handleChange(e);
  };

  get initialFormValues() {
    const {
      quote: { application },
    } = this.props;
    return {
      ownersCount: get(application, 'answers.owners_count', ''),
    };
  }

  render() {
    return (
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-7 p-t-30">
            <h3 className="text-center semi-bold">
              How many individuals have an ownership interest in the company for
              which you are seeking coverage?
            </h3>
            <div className="card m-t-20">
              <div className="card-block">
                <div className="form-group">
                  <Formik
                    initialValues={this.initialFormValues}
                    isInitialValid={this.handleInitialValidation}
                    validationSchema={this.formValidationSchema}
                    onSubmit={this.handleSubmit}
                    innerRef={(c) => (this.form = c)}
                  >
                    {({
                      values,
                      handleSubmit,
                      handleBlur,
                      touched,
                      errors,
                    }) => {
                      return (
                        <form className="row" onSubmit={handleSubmit}>
                          <label className="col-md-3 text-uppercase">
                            Owners
                          </label>

                          <div className="col-md-9">
                            <label
                              htmlFor="ownersCount"
                              className={classnames('text-uppercase', {
                                'BOAEnrollmentOwnershipView-label--hasError':
                                  errors.ownersCount,
                              })}
                            >
                              {errors.ownersCount || 'Number of owners'}
                            </label>
                            <input
                              className="BOAEnrollmentOwnershipView-input"
                              name="ownersCount"
                              value={values.ownersCount}
                              disabled={this.state.isInProgress}
                              onBlur={handleBlur}
                              onChange={this.handleChange}
                              touched={touched.ownersCount ? 'true' : 'false'}
                              error={errors.ownersCount}
                            />
                          </div>
                          <input
                            type="submit"
                            style={{ display: 'none' }}
                            ref={(c) => (this.inputSubmit = c)}
                          />
                        </form>
                      );
                    }}
                  </Formik>
                </div>
              </div>
            </div>

            <div className="row justify-content-center">
              <button
                className="btn btn-lg btn-complete"
                disabled={!this.state.isValid || this.state.isInProgress}
                onClick={() => this.inputSubmit.click()}
                type="button"
              >
                Next
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

BOAEnrollmentOwnershipView.propTypes = propTypes;

export default BOAEnrollmentOwnershipView;
